module.exports = __webpack_public_path__ + "img/mad.f4ff3dec.png";